export default "__VITE_ASSET__5GcuIAKy__"